<template>
  <span class="ics-tag" :class="icsType">{{ icsTagText }}</span>
</template>

<script>
export default {
  props: ['icsType'],
  computed: {
    icsTagText() {
      let output = '';
      switch (this.icsType) {
        case 'i':
          output = this.$t('main.MIDLAND_I');
          break;
        case 'c':
          output = this.$t('main.MIDLAND_C');
          break;
        case 's':
          output = this.$t('main.MIDLAND_S');
          break;
        default:
          break;
      }
      return output;
    },
  },
};
</script>

<style scoped>
.ics-tag {  
  height: 20px;
  padding: 0px 3px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 3px;
  color: #000;
  background: #ffe100;
}
</style>